import { render } from "./candidate-reference-prospect.fieldset.vue?vue&type=template&id=621faff7"
import script from "./candidate-reference-prospect.fieldset.vue?vue&type=script&lang=js"
export * from "./candidate-reference-prospect.fieldset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QInput});
